import React from 'react';
import '../components/HomeView/Home.css'
import {TopMenuLinks} from "../components/HomeView/TopMenuLinks";
import {TopMenuLogo} from "../components/HomeView/TopMenuLogo";
import skullImage from "./../img/skull2.png"
import {MobileSearchBar} from "../components/HomeView/MobileSearchBar";
import './../components/PageNotFoundView/PageNotFoundView.css'
import {DetailsItem} from "../components/HomeView/Details/DetailsItem";
import {PortraitsItem} from "../components/PortraitsView/PortraitsItem";

import pic1 from './../img/portraits/1.png'
import pic2 from './../img/portraits/2.png'
import pic3 from './../img/portraits/3.png'
import pic4 from './../img/portraits/4.png'
import pic5 from './../img/portraits/5.png'
import pic6 from './../img/portraits/6.png'
import pic7 from './../img/portraits/7.png'
import pic8 from './../img/portraits/8.png'
import pic9 from './../img/portraits/9.png'
import pic10 from './../img/portraits/10.png'

import pic11 from './../img/portraits/11.png'
import pic12 from './../img/portraits/12.png'
import pic13 from './../img/portraits/13.png'
import pic14 from './../img/portraits/14.png'
import pic15 from './../img/portraits/15.png'
import pic16 from './../img/portraits/16.png'
import pic17 from './../img/portraits/17.png'
import pic18 from './../img/portraits/18.png'
import pic19 from './../img/portraits/19.png'
import pic20 from './../img/portraits/20.png'

import pic21 from './../img/portraits/21.png'
import pic22 from './../img/portraits/22.png'
import pic23 from './../img/portraits/23.png'
import pic24 from './../img/portraits/24.png'
import pic25 from './../img/portraits/25.png'
import pic26 from './../img/portraits/26.png'
import pic27 from './../img/portraits/27.png'
import pic28 from './../img/portraits/28.png'
import pic29 from './../img/portraits/29.png'
import pic30 from './../img/portraits/30.png'

import pic31 from './../img/portraits/31.png'
import pic32 from './../img/portraits/32.png'
import pic33 from './../img/portraits/33.png'
import pic34 from './../img/portraits/34.png'
import pic35 from './../img/portraits/35.png'
import pic36 from './../img/portraits/36.jpg'
import pic37 from './../img/portraits/37.jpg'
import pic38 from './../img/portraits/38.jpg'
import pic39 from '../img/portraits/39.jpg'
import {useNavigate} from "react-router-dom";

export const PortraitsView = (props) => {

    const navigate = useNavigate();
    const routeChange = () => {
        navigate("/");
    }

    return <div className='PageBackground'>
        <TopMenuLogo/>
        <MobileSearchBar/>
        <TopMenuLinks/>
        <div style={{textAlign: 'center'}}>
            <div className='PortraitViewBodyContainer'>
                <div style={{
                    display: 'flex',
                    paddingTop: '1%',
                    paddingBottom: '1%',
                    paddingLeft: '2.5%',
                    color: 'white',
                    fontWeight: 'bold',
                    backgroundColor: 'rgb(113,152,202)',

                }}>
                    <button
                        onClick={() => {routeChange()}}
                        type="primary"
                        className='PortraitViewBackButton'
                    >
                        &lt; Back
                    </button>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                    Matt's Pictures
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    height: '100%',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <PortraitsItem picture={pic39}/>
                    <PortraitsItem picture={pic38}/>
                    <PortraitsItem picture={pic37}/>
                    <PortraitsItem picture={pic36}/>

                    <PortraitsItem picture={pic1}/>
                    <PortraitsItem picture={pic2}/>
                    <PortraitsItem picture={pic3}/>
                    <PortraitsItem picture={pic4}/>
                    <PortraitsItem picture={pic5}/>
                    <PortraitsItem picture={pic6}/>
                    <PortraitsItem picture={pic7}/>
                    <PortraitsItem picture={pic9}/>

                    <PortraitsItem picture={pic11}/>
                    <PortraitsItem picture={pic12}/>
                    <PortraitsItem picture={pic13}/>
                    <PortraitsItem picture={pic14}/>
                    <PortraitsItem picture={pic15}/>
                    <PortraitsItem picture={pic16}/>
                    <PortraitsItem picture={pic17}/>
                    <PortraitsItem picture={pic18}/>
                    <PortraitsItem picture={pic19}/>

                    <PortraitsItem picture={pic20}/>
                    <PortraitsItem picture={pic21}/>
                    <PortraitsItem picture={pic22}/>
                    <PortraitsItem picture={pic23}/>
                    <PortraitsItem picture={pic24}/>
                    <PortraitsItem picture={pic25}/>
                    <PortraitsItem picture={pic26}/>
                    <PortraitsItem picture={pic27}/>
                    <PortraitsItem picture={pic28}/>
                    <PortraitsItem picture={pic29}/>

                    <PortraitsItem picture={pic30}/>
                    <PortraitsItem picture={pic31}/>
                    <PortraitsItem picture={pic32}/>
                    <PortraitsItem picture={pic33}/>
                    <PortraitsItem picture={pic34}/>
                    <PortraitsItem picture={pic35}/>


                </div>
            </div>
        </div>
    </div>
}

